<template>
  <div>
    <pc-header></pc-header>
    <business />
    <router-view />
    <pc-footer></pc-footer>
  </div>
</template>

<script>
import business from './Business.vue'
export default {
  name: 'navLayout',
  components: {
    business,
  },
}
</script>

<style lang="less" scoped>
</style>